export interface ComingSoonFeatureConfig {
  title: string
  description: string
  featureList: string[]
}

export const TOOLS_COMING_SOON_CONFIG: ComingSoonFeatureConfig = {
  title: 'Platform Tools - Coming Soon',
  description: 'Powerful platform-integrated tools to boost your productivity and analysis.',
  featureList: [
    'SEO Audit Tools (Lighthouse, SEMrush)',
    'Content Analysis & Optimization',
    'Performance Metrics Dashboard',
    'Keyword Research Tools',
    'Competitor Analysis',
  ],
}
